// Chart palette for the admin analytics tab.
//
// The eight categorical hues are assigned in FIXED SLOT ORDER and never cycled:
// a series keeps its hue when other series are filtered out, so "blue is
// signups" stays true. Validated (OKLab CVD ΔE, chroma, lightness band and
// contrast) against this panel's white card surface — worst adjacent CVD ΔE 9.1,
// worst adjacent normal-vision ΔE 19.6. Three slots (aqua/yellow/magenta) sit
// below 3:1 contrast on white, so every chart ships a legend plus a table view
// — identity and values are never carried by hue alone.
export const SERIES_COLORS = [
	'#2a78d6', // 1 blue
	'#eb6834', // 2 orange
	'#1baf7a', // 3 aqua
	'#eda100', // 4 yellow
	'#e87ba4', // 5 magenta
	'#008300', // 6 green
	'#4a3aa7', // 7 violet
	'#e34948', // 8 red
];

/** Slot colour by index. Past 8 series we fold to "Other" rather than cycle. */
export const seriesColor = (index: number): string =>
	SERIES_COLORS[index] ?? SERIES_COLORS[SERIES_COLORS.length - 1];

/** Single-hue blue ramp (light → dark) for magnitude: the retention heatmap. */
export const SEQUENTIAL_BLUE = [
	'#cde2fb',
	'#b7d3f6',
	'#9ec5f4',
	'#86b6ef',
	'#6da7ec',
	'#5598e7',
	'#3987e5',
	'#2a78d6',
	'#256abf',
	'#1c5cab',
	'#184f95',
	'#104281',
];

/** Chart chrome — recessive by design; the data is the only loud thing. */
export const INK = {
	surface: '#ffffff',
	primary: '#0b0b0b',
	secondary: '#52514e',
	muted: '#898781',
	grid: '#e1e0d9',
	axis: '#c3c2b7',
};

/** Direction colours for deltas. Reserved for good/bad, never for a series. */
export const DELTA = {
	up: '#006300',
	down: '#d03b3b',
	flat: '#898781',
};
